import { BypassBlock } from '@packages/shared/src/ui/BypassBlock/BypassBlock';
import { ConditionalWrapper } from '@packages/shared/src/ui/ConditionalWrapper/ConditionalWrapper';
import { ComponentRecognizer } from '../ComponentRecognizer/ComponentRecognizer';
import type { ContentControlType } from './types';

const BypassWrapper = (skipLinkLabel: string) => (ch: React.ReactNode) => (
  <BypassBlock buttonText={skipLinkLabel}>{ch}</BypassBlock>
);

const DynamicYieldWrapper = (dynamicYieldId: string) => (ch: React.ReactNode) => (
  <div data-dy={dynamicYieldId}>{ch}</div>
);

/**
 * Content block container for miscellaneous use cases,
 * like adding a skip link around content
 * or adding a dynamic yield id to the surrounding div element.
 */
export const ContentControl = ({
  data: {
    field_skip_link_label: skipLinkLabel,
    behavior_paragraph_custom_id: dynamicYieldId,
    behavior_paragraph_accessibility_checkbox: enableSkipLink,
    paragraph,
  },
}: {
  data: ContentControlType;
}) => (
  <ConditionalWrapper
    condition={Boolean(enableSkipLink && skipLinkLabel)}
    wrapper={BypassWrapper(skipLinkLabel ?? '')}
  >
    <ConditionalWrapper
      condition={Boolean(dynamicYieldId)}
      wrapper={DynamicYieldWrapper(dynamicYieldId ?? '')}
    >
      {paragraph &&
        paragraph.length > 0 &&
        paragraph.map((item) => <ComponentRecognizer key={item.id} item={item} />)}
    </ConditionalWrapper>
  </ConditionalWrapper>
);
